"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invoiceUtils = void 0;
const __1 = require("..");
const getAmount = (invoice) => {
    return __1.numberUtils.twoDecimals((invoice === null || invoice === void 0 ? void 0 : invoice.amount) || 0);
};
const getSubtotal = (invoice) => {
    if (!invoice.order)
        throw new Error("No order found on invoice");
    return __1.numberUtils.twoDecimals((invoice === null || invoice === void 0 ? void 0 : invoice.amount) || 0);
};
const getTotal = (invoice) => {
    var _a, _b, _c;
    let total = getSubtotal(invoice);
    if (!invoice.order)
        throw new Error("No order found on invoice");
    if (invoice.type === __1.EInvoiceType.saldo) {
        total += (_a = invoice === null || invoice === void 0 ? void 0 : invoice.order) === null || _a === void 0 ? void 0 : _a.packingCost;
        total += (_b = invoice === null || invoice === void 0 ? void 0 : invoice.order) === null || _b === void 0 ? void 0 : _b.transportCost;
        total += (_c = invoice === null || invoice === void 0 ? void 0 : invoice.order) === null || _c === void 0 ? void 0 : _c.importDuties;
    }
    return total;
};
const getVAT = (invoice) => {
    var _a;
    if (!(invoice === null || invoice === void 0 ? void 0 : invoice.order))
        throw new Error("No order found on invoice");
    const amount = getTotal(invoice);
    const vat = __1.numberUtils.twoDecimals((amount * (((_a = invoice === null || invoice === void 0 ? void 0 : invoice.order) === null || _a === void 0 ? void 0 : _a.vatPercentage) || 0)) / 100);
    return vat;
};
const getTotalInclVAT = ({ invoice, order, }) => {
    const subtotal = getSubtotal(invoice);
    const vat = getVAT(invoice);
    return __1.numberUtils.twoDecimals(subtotal + vat);
};
const getTotalAdvanced = (invoices) => {
    const totalAdvanced = (invoices || [])
        .filter((invoice) => invoice.type === __1.EInvoiceType.advance)
        .reduce((acc, { amount }) => {
        acc += amount || 0;
        return acc;
    }, 0);
    return totalAdvanced;
};
exports.invoiceUtils = {
    getAmount,
    getSubtotal,
    getVAT,
    getTotal,
    getTotalInclVAT,
    getTotalAdvanced,
};
//# sourceMappingURL=invoiceUtils.js.map